import { FC } from 'react';
import { translate } from '../../i18n';
import { paymentErrorBoxStyles } from './styles';

export interface PaymentErrorBoxProps {
  message: string;
  testID?: string;
  title?: string;
  accessibilityLabel?: string;
}

/**
 * PaymentErrorBox — Caja para mostrar errores de pago
 *
 * Cambios:
 * ✅ Estilos centralizados en styles.ts
 * ✅ i18n para title por defecto
 * ✅ Cero Tailwind, cero hardcodes
 */
export const PaymentErrorBox: FC<PaymentErrorBoxProps> = ({
  message,
  testID = 'payment-error-box',
  title = translate('paymentsUI.errorBox.title'),
  accessibilityLabel = message,
}) => (
  <div
    style={paymentErrorBoxStyles.container}
    data-testid={testID}
    role="alert"
    aria-label={accessibilityLabel}
  >
    {title && (
      <p style={paymentErrorBoxStyles.title} data-testid={`${testID}-title`}>
        {title}
      </p>
    )}
    <p style={paymentErrorBoxStyles.message} data-testid={`${testID}-message`}>
      {message}
    </p>
  </div>
);
